export default __webpack_public_path__ + "assets/load_thumbnail.png";